import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'

export const TriggerButton = ({ onClick }) => {
  return <BusyButton icon={'plus'} text="Add new..." onClick={onClick} />
}
